import { IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { PropsWithChildren } from 'react';

export type TransactionModalProps = PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  title: string;
}>;

export const TransactionModal = ({title, isOpen, onClose, children}: TransactionModalProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  // Genişlik ve yüksekliği ekran boyutlarına göre ayarladık.
  const widthValue = isDesktop ? '80%' : '95%';  
  const heightValue = isDesktop ? '80%' : '95%';  

  return(
    <Modal open={isOpen} onClose={onClose} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
      <Stack  sx={{overflow: 'hidden', borderRadius: 2, width: widthValue, height: heightValue, backgroundColor: '#FFF', p: 2 /* padding eklendi */}}>
        <Stack direction="row" sx={{borderRadius: 2, px: 2, py: 1, backgroundColor: 'white', justifyContent: 'space-between', alignItems: 'center'}}>
          <Typography variant='h4'>{title}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Stack flex={1} sx={{ overflow: 'auto' }}>
          {children}
        </Stack>
      </Stack>
    </Modal>
  )
}
